import React from "react";
import { TableRow, TableHeaderCell, TableHeader, TableCell, TableBody, Table, Header } from "semantic-ui-react";
import Cards from "./cards";

import Avatar from "./Avatar.jsx";
import newUtils from "../newUtils.js";


const doCurrency = (value) => {
    var val = value?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return val;
};
/* const doCurrencyMil = (value, fix) => {
    var val;
    if (value < 1000000) {
        val = doCurrency(parseFloat(value / 1000).toFixed(fix || fix ==== 0 ? fix : 0)) + "K";
    } else {
        val = doCurrency(parseFloat(value / 1000000).toFixed(fix || fix ==== 0 ? fix : 1)) + "M";
        val = val.replace(".0", "");
    }
    if (value ==== 0) {
        return 0;
    }
    return val;
};
 */
const TableExampleSelectableInvertedRow = (prop) => (
    <Table celled inverted size="tiny">
        <TableHeader>
            <TableRow>
                <TableHeaderCell width={4}>
                
                    {prop.table?.table_name} - Total: {doCurrency(prop.table?.total)}
                    <br />
                    <small>{prop.table?.hand_number}</small>
                    <br />
                    <small>{prop.table?.updatePlayer}</small>
                    <br />
                    <small>{prop.table?.topRankPlayer > prop.table?.topRankBot ? prop.table?.topRankPlayer : prop.table?.topRankBot}</small>
                   
                   
                    {/*    {prop.table?.flushout && (
                        <>
                            {Object.keys(prop.table?.flushout).map(function (key) {
                                var Seat = prop.table?.flushout[key];

                                if (Seat.canFlush) {
                                    return (
                                        <div style={!Seat.canFlush ? { textDecoration: "line-through" } : {}}>
                                            {Seat.card} {Seat.out}% nuts:{Seat.nuts} high:{Seat.high}
                                        </div>
                                    );
                                }
                            })}
                        </>
                    )}
                    {prop.table?.perout && (
                        <>
                            {Object.keys(prop.table?.perout).map(function (key) {
                                var Seat = prop.table?.perout[key];

                                return (
                                    <div>
                                        {Seat.card} {Seat.out}%
                                    </div>
                                );
                            })}
                        </>
                    )} */}
                </TableHeaderCell>
                <TableHeaderCell width={12}>
                    <Cards cards={prop.table?.board_cards[0].filter((d) => d !== "15c" && d !== "1" && d !== "0")} />
                    <Header as="h4" floated="left" inverted>
                        Rank: {prop.table?.boardrank}
                        <br />
                        Helper: {prop.table?.boardOdds}
                        <br />
                    </Header>
                </TableHeaderCell>
                {/*     <TableHeaderCell width={10}>

                    <div className="smallcardb4lock">
                        {prop.table?.allCards &&<Cards cards={prop.table?.allCards.filter((d) => d !== "15c" && d !== "1" && d !== "0")} />}
                    </div>
                </TableHeaderCell>  */}
            </TableRow>
        </TableHeader>

        <TableBody>
            {!prop?.table?.players ? (
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    {/* <TableCell textAlign="right"></TableCell> */}
                </TableRow>
            ) : (
                <>
                    {prop.table?.players.map(function (Seat, i) {
                       
                            const obj = prop.table.players;

                            var topRank = prop.table?.topRankPlayer > prop.table?.topRankBot ? prop.table?.topRankPlayer : prop.table?.topRankBot;
                            // var winnerMode = obj?.topRankPlayer > obj.topRankBot ? "Player" : 'Bot';
                            var allDdraw = Seat.draw;
                            /* if (prop.table?.stage === "preflop") {
                                Object.keys(Seat.perOdds).map(function (key) {
                                    var Flushs = Seat.perOdds[key];
                                    allDdraw = allDdraw + Flushs.out;
                                });

                                Object.keys(Seat.flushOdds).map(function (key) {
                                    var Flushs = Seat.flushOdds[key];
                                    var Out = prop.table?.flushout[key];

                                    var inHigh = newUtils.CleanOddsFlsuh(Seat, obj, key, Out);
                                    if (inHigh) {
                                        allDdraw = allDdraw + Flushs.out;
                                    }
                                });
                            } else {
                               
                            } */

                            return (
                                <TableRow key={i} color={topRank <= Seat.rank ? "red" : ""} style={prop.table?.turn === Seat.Seat ? { backgroundColor: "#92af00ff" }:{}}>
                                    <TableCell style={topRank === Seat.rank ? { backgroundColor: "red" } : {}}>
                                        <Avatar username={Seat.username} isBot={Seat.Bot} />
                                        Chips: {doCurrency(parseFloat(Seat.Chips).toFixed(2))} <br />
                                        inPot: {doCurrency(parseFloat(Seat.NetChips - Seat.Chips).toFixed(2))}
                                        
                                        <br />
                                        Net:{doCurrency(parseFloat(Seat.Net).toFixed(2))}
                                        <br />
                                        allDdraw:{doCurrency(allDdraw)}
                                        {prop.table?.stage === "preflop" ? (
                                            <>
                                               {/*  {Object.keys(Seat.perOdds).map(function (key) {
                                                    var Flushs = Seat.perOdds[key];

                                                    var Out = prop.table?.perout[key];

                                                   
                                                        return (
                                                            <div style={Out?.out === 0 ? { textDecoration: "line-through" } : {}}>
                                                                {key} out:{Flushs.out}
                                                            </div>
                                                        );
                                                    
                                                })}
                                                <br />
                                                {Object.keys(Seat.flushOdds).map(function (key) {
                                                    var Flushs = Seat.flushOdds[key];
                                                    var Out = prop.table?.flushout[key];

                                                    var inHigh = newUtils.CleanOddsFlsuh(Seat, obj, key, Out);
                                                   
                                                        return (
                                                            <div style={!inHigh ? { textDecoration: "line-through" } : {}}>
                                                                {key} high:{Flushs.high} out:{Flushs.out} nuts:{Out.nuts} high:{Out.high}
                                                            </div>
                                                        );
                                                    
                                                })} */}
                                            </>
                                        ) : (
                                            <>
                                                {Seat?.Odds && (
                                                    <>
                                                        {Object.keys(Seat?.Odds).map(function (key) {
                                                            var odds = JSON.stringify(Seat.Odds[key]);

                                                            var Out = prop.table?.perout[key];

                                                            if (key !== "Player" && odds.indexOf("{") > -1) {
                                                                return (
                                                                    <div>
                                                                        {key} : {odds}
                                                                    </div>
                                                                );
                                                            }
                                                        })}
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        <Cards cards={Seat.hole_cards.filter((d) => d !== "15c" && d !== "1" && d !== "0")} />
                                        {Seat?.hand_helper}
                                        <br />
                                        Rank: {Seat.rank}
                                        <br />
                                        Bet: {doCurrency(parseFloat(Seat.Bet).toFixed(2))}
                                        <br />
                                        {Seat?.dt?.Button1} - {Seat?.dt?.Button2}({Seat?.dt?.Call}) - {Seat?.dt?.Button3}({Seat?.dt?.MinRaise})-({Seat?.dt?.MaxRaise})
                                        <br />
                                        Action: {Seat.action}
                                      
                                        
                                    </TableCell>
                                </TableRow>
                            );
                        
                    })}
                </>
            )}
        </TableBody>
    </Table>
);

export default TableExampleSelectableInvertedRow;
